import { ReactNode } from 'react'
import Modal from '../../../../shared/Modal'
import { BellIcon } from './BellIcon'
import styles from './SavedSearchAlertModal.module.scss'

export interface SavedSearchAlertModalProps {
  children: ReactNode
  hideAlertModal: () => void
}

export const SavedSearchAlertModal = ({
  children,
  hideAlertModal,
}: SavedSearchAlertModalProps) => (
  <Modal
    className={styles.alertModal}
    toggle={hideAlertModal}
    backdropOpacity='5'
    overrideContent
    open
  >
    <div className={styles.container}>
      <BellIcon />
      {children}
    </div>
  </Modal>
)
